<template>
    <div class="ios-back-button" :class="{ 'ios-back-button--active': isIosBackButton }">
        <div class="ios-back-button__inner">
            <div :class="{ ipad: isIPad }" @click="handleClick">
                <img src="https://images.iphonephotographyschool.com/36166/back-button.svg" alt="" />
                <span class="ios-back-button__text"> Back</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {
            startY: 0,
        };
    },
    computed: {
        ...mapState(['isIosBackButton']),
        backUrl() {
            switch (window.App.appEnvironment) {
                case 'production':
                    return 'https://courses.iphonephotographyschool.com';
                case 'local':
                    return 'http://courses.ips.test/';
                default:
                    return `https://${window.App.appEnvironment}-courses.iphonephotographyschool.com`;
            }
        },
        isIPad() {
            if (
                /iPad/i.test(navigator.userAgent) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 && !window.MSStream)
            ) {
                return true;
            }
        },
    },
    watch: {
        isIosBackButton: {
            immediate: true,
            handler(value) {
                const topElems = document.querySelectorAll('.timer-top-banner, .limited-spots');

                if (value) {
                    topElems.forEach((elem) => {
                        elem?.classList.add('back-active');
                    });
                } else {
                    topElems.forEach((elem) => {
                        elem?.classList.remove('back-active');
                    });
                }
            },
        },
    },
    methods: {
        handleScroll() {
            const scrollY = window.scrollY;

            if (scrollY > this.startY && scrollY > 0) {
                this.$store.commit('setIosBackButtonVisible', false);
            } else {
                this.$store.commit('setIosBackButtonVisible', true);
            }

            this.startY = scrollY;
        },
        handleClick() {
            window.ipse.dispatch({
                action: 'button_clicked',
                data_event: {
                    button: 'ios_back_button_clicked',
                },
            });

            window.location.href = this.backUrl;
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>

<style></style>
